import type { HeroProps as Props } from './types';
import { cls } from '@/utils/cls';
import { HeroImagePlacements, TextAlignmentOptions } from '@/constants';
import style from './Hero.module.scss';
import RichText from '../RichText';
export default function Hero({
  extendStyles,
  heading,
  headingAlignment = TextAlignmentOptions.LEFT,
  copy,
  copyAlignment = TextAlignmentOptions.LEFT,
  foregroundImage,
  backgroundImage,
  lowerCopy,
  mobileHeading,
  mobileCopy,
  mobileCopyAlignment = TextAlignmentOptions.LEFT,
  mobileForegroundImage,
  mobileBackgroundImage,
  mobileLowerCopy,
  narrowWidth,
  textBox,
  fullWidth = false,
  showList,
  listItems,
  hideCopy,
  smallBullets,
  centerBullets
}: Props) {
  const _className = cls(style.root, extendStyles);
  const image = !!foregroundImage?.src;
  const mobileImage = !!mobileForegroundImage?.src;
  const imageLeft = foregroundImage?.imgSide === HeroImagePlacements.LEFT;
  const mobileImageLeft = mobileForegroundImage?.imgSide === HeroImagePlacements.LEFT;
  const lowerClassNames = cls(style.lower, style[copyAlignment]);
  const narrowClass = narrowWidth ? style.narrow : '';
  const wrapperClass = cls(textBox ? style.visualWrapper : '', narrowWidth ? style.narrow : '');
  const bulletClass = cls(smallBullets ? style.iconSmall : style.icon, centerBullets ? style.centerBullets : '');
  return <section className={_className} data-sentry-component="Hero" data-sentry-source-file="Hero.tsx">
			{backgroundImage?.src && <div className={cls(style.background, style.desktop)} role="presentation" style={{
      opacity: backgroundImage.backgroundOpacity
    }}>
					<img src={backgroundImage.src} alt="" role="presentation" data-placement={backgroundImage.backgroundImagePlacement} />
				</div>}
			{mobileBackgroundImage?.src && <div className={cls(style.background, style.mobile)} role="presentation" style={{
      opacity: mobileBackgroundImage.backgroundOpacity
    }}>
					<img src={mobileBackgroundImage.src} alt="" role="presentation" data-placement={mobileBackgroundImage.backgroundImagePlacement} />
				</div>}
			<div className={cls(style.grid, style.desktop)} data-grid>
				<div className={cls(wrapperClass, fullWidth && style.fullWidth)} data-testid="hero">
					{heading && <RichText text={heading} className={cls(style.heading, narrowClass)} data-align={headingAlignment} />}
					<article className={cls(style.wrapper, imageLeft && style.reverse, style[copyAlignment], narrowClass)}>
						{!hideCopy && <div className={style.middleWrap}>
								{imageLeft && image && <img src={foregroundImage.src} alt={foregroundImage.alt || ''} />}
								{copy && <RichText text={copy} className={style.copy} data-align={copyAlignment} />}
								{!imageLeft && image && <img src={foregroundImage.src} alt={foregroundImage.alt || ''} />}
							</div>}

						{showList && listItems && listItems.length > 0 && <div className={style.list} data-testid="list-section">
								{listItems.map((item, index) => <div key={index} className={style.listItem}>
										{item.icon && <img src={item.icon} alt="" role="presentation" className={bulletClass} />}
										<div className={style.itemContent}>
											<RichText text={item.content} />
										</div>
									</div>)}
							</div>}

						{lowerCopy && <div className={lowerClassNames}>
								<RichText text={lowerCopy} className={style.copy} data-align={copyAlignment} />
							</div>}
					</article>
				</div>
			</div>
			<div className={cls(style.grid, style.mobile)} data-grid>
				{mobileHeading && <RichText text={mobileHeading} className={style.heading} />}
				<article className={mobileImageLeft ? cls(style.wrapper, style.reverse, style[mobileCopyAlignment]) : cls(style.wrapper, style[mobileCopyAlignment])}>
					<div className={style.middleWrap}>
						{mobileImageLeft && mobileImage && <img src={mobileForegroundImage.src} alt={mobileForegroundImage.alt || ''} />}
						{mobileCopy && <RichText text={mobileCopy} className={style.copy} data-align={mobileCopyAlignment} />}
						{!mobileImageLeft && mobileImage && <img src={mobileForegroundImage.src} alt={mobileForegroundImage.alt || ''} />}
					</div>

					{mobileLowerCopy && <div className={lowerClassNames}>
							<RichText text={mobileLowerCopy} className={style.copy} data-align={mobileCopyAlignment} />
						</div>}
				</article>
			</div>
		</section>;
}